<ng-container *ngIf="profile !== undefined; else spinner">
  <mzima-client-button
    tabindex="-1"
    fill="outline"
    [iconOnly]="true"
    color="light-gray"
    [data-qa]="'btn-close'"
    class="modal__close-btn"
    [mat-dialog-close]="false"
    ariaLabel="{{ 'modal.button.close' | translate }}"
  >
    <mat-icon icon svgIcon="close"></mat-icon>
  </mzima-client-button>

  <div class="content">
    <mat-tab-group
      [(selectedIndex)]="selectedTabIndex"
      (selectedIndexChange)="getTabInformation()"
      dynamicHeight
      disablePagination
      animationDuration="0ms"
    >
      <mat-tab
        label="{{ 'user_profile.nav.account_settings' | translate }}"
        labelClass="profile-tab-account-settings"
      >
        <div class="tab-content" *ngIf="!isLoading; else spinner" mat-dialog-content>
          <form novalidate [formGroup]="profileForm" (ngSubmit)="updateProfile()">
            <div class="form-row">
              <mat-label>{{ 'user.role' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput readonly formControlName="role" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-label>{{ 'user.full_name' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="display_name" />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-label>{{ 'user.email' | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="email" formControlName="email" />
                <mat-error *ngIf="profileForm.controls['email'].errors">
                  <p>{{ 'user.valid.fields.email must be valid' | translate }}</p>
                </mat-error>
              </mat-form-field>
            </div>

            <mat-accordion class="update-password" #updatePasswordFields>
              <mat-expansion-panel
                [expanded]="isUpdatingPassword"
                (opened)="updatePassword(true)"
                (closed)="updatePassword(false)"
              >
                <mat-expansion-panel-header>
                  {{ 'user.update_password' | translate }}
                </mat-expansion-panel-header>

                <div class="form-row">
                  <mat-label>{{ 'user.password' | translate }}</mat-label>
                  <mat-form-field appearance="outline">
                    <input matInput type="password" formControlName="password" />
                    <mat-error *ngIf="profileForm.controls['password'].errors">
                      <p>{{ 'user.password_length' | translate }}</p>
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="form-row">
                  <mat-label>{{ 'user.confirm_password' | translate }}</mat-label>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      type="password"
                      formControlName="confirmPassword"
                      [errorStateMatcher]="matcher"
                    />
                    <mat-error
                      *ngIf="
                        profileForm.hasError('notSame') || profileForm.controls['password'].errors
                      "
                    >
                      <p *ngIf="profileForm.controls['password'].errors">
                        {{ 'user.password_length' | translate }}
                      </p>
                      <p *ngIf="profileForm.hasError('notSame')">
                        {{ 'user.password_match' | translate }}
                      </p>
                    </mat-error>
                  </mat-form-field>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </form>
        </div>
      </mat-tab>
      <mat-tab
        label="{{ 'user_profile.nav.notifications_settings' | translate }}"
        labelClass="profile-tab-norifications"
        id="profile-tab-norifications"
      >
        <div class="tab-content" *ngIf="!isLoading; else spinner" mat-dialog-content>
          <mat-accordion class="contacts" multi>
            <mat-expansion-panel class="contacts-tab" expanded>
              <mat-expansion-panel-header>
                <h4 class="contacts-tab__title">
                  {{ 'notification.contacts_heading' | translate }}
                </h4>
              </mat-expansion-panel-header>

              <mat-accordion class="contacts">
                <mat-expansion-panel *ngFor="let contact of contacts" class="contact-item">
                  <mat-expansion-panel-header>
                    <span class="contacts-tab__title">{{ contact.contact }}</span>
                    <span class="contact-item__is-active" *ngIf="contact.can_notify"></span>
                  </mat-expansion-panel-header>

                  <mat-slide-toggle
                    [(ngModel)]="contact.can_notify"
                    (ngModelChange)="isContactsChanged = true"
                  >
                    {{ 'notification.send_to_address' | translate }}
                  </mat-slide-toggle>

                  <div class="form-row">
                    <mat-label>{{
                      (contact.type === 'email'
                        ? 'contact.edit_email_address'
                        : 'contact.edit_phone_number'
                      ) | translate
                    }}</mat-label>
                    <mat-form-field appearance="outline">
                      <input
                        matInput
                        [(ngModel)]="contact.contact"
                        (ngModelChange)="validateContact(contact)"
                      />
                    </mat-form-field>
                    <mat-error *ngIf="errorMap[contact.id]">
                      {{ errorMap[contact.id] }}
                    </mat-error>
                  </div>

                  <div class="contact-item__buttons">
                    <mzima-client-button
                      color="danger"
                      (buttonClick)="deleteContact(contact.id)"
                      [expand]="false"
                    >
                      {{ 'contact.button.delete' | translate }}
                    </mzima-client-button>
                  </div>
                </mat-expansion-panel>
                <mat-expansion-panel
                  (opened)="isAddAccountFormOpen = true"
                  (closed)="isAddAccountFormOpen = false"
                  class="contact-item contact-item--add-new"
                >
                  <mat-expansion-panel-header>
                    <span class="contacts-tab__title">{{ 'contact.button.add' | translate }}</span>
                  </mat-expansion-panel-header>

                  <form novalidate (ngSubmit)="addAccount()" [formGroup]="addAccountForm">
                    <div class="form-row">
                      <mat-radio-group
                        formControlName="type"
                        (change)="accountFormatChanged($event)"
                      >
                        <div class="radio-button" *ngFor="let accountType of accountTypes">
                          <mat-radio-button [value]="accountType.value">
                            {{ accountType.name }}
                          </mat-radio-button>
                        </div>
                      </mat-radio-group>
                    </div>

                    <div class="form-row">
                      <mat-label>{{
                        (addAccountForm.controls['type'].value === 'email'
                          ? 'contact.add_email_address'
                          : 'contact.add_phone_number'
                        ) | translate
                      }}</mat-label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          formControlName="name"
                          [placeholder]="
                            (addAccountForm.controls['type'].value === 'email'
                              ? 'contact.add_email_address'
                              : 'contact.add_phone_number'
                            ) | translate
                          "
                        />
                      </mat-form-field>
                    </div>

                    <mzima-client-button
                      type="submit"
                      [expand]="false"
                      [disabled]="
                        addAccountForm.invalid || addAccountForm.pristine || addAccountForm.disabled
                      "
                    >
                      {{ 'contact.button.add' | translate }}
                    </mzima-client-button>
                  </form>
                </mat-expansion-panel>
              </mat-accordion>
            </mat-expansion-panel>

            <mat-expansion-panel *ngIf="notifications?.length" class="contacts-tab" expanded>
              <mat-expansion-panel-header>
                <h4 class="contacts-tab__title">
                  {{ 'notification.what_you_get_notification_about' | translate }}
                </h4>
              </mat-expansion-panel-header>

              <div class="contacts">
                <div
                  class="notification-group"
                  *ngIf="filteredNotifications(NotificationTypeEnum.Collection)?.length"
                >
                  <span class="notification-group__title">{{ 'app.collections' | translate }}</span>
                  <div
                    *ngFor="
                      let notification of filteredNotifications(NotificationTypeEnum.Collection)
                    "
                    class="notification"
                  >
                    <span class="notification__title">{{ notification.set_name }}</span>
                    <mzima-client-button
                      fill="clear"
                      color="secondary"
                      [iconOnly]="true"
                      class="notification__btn"
                      (buttonClick)="deleteNotification(notification.id.toString())"
                      [ariaLabel]="'notification.button.delete' | translate"
                    >
                      <mat-icon icon svgIcon="delete"></mat-icon>
                    </mzima-client-button>
                  </div>
                </div>
                <div
                  class="notification-group"
                  *ngIf="filteredNotifications(NotificationTypeEnum.SavedSearch)?.length"
                >
                  <span class="notification-group__title">{{
                    'global_filter.saved_filters' | translate
                  }}</span>
                  <div
                    *ngFor="
                      let notification of filteredNotifications(NotificationTypeEnum.SavedSearch)
                    "
                    class="notification"
                  >
                    <span class="notification__title">{{ notification.set_name }}</span>
                    <mzima-client-button
                      fill="clear"
                      color="secondary"
                      [iconOnly]="true"
                      class="notification__btn"
                      [ariaLabel]="'notification.button.delete' | translate"
                      (buttonClick)="deleteNotification(notification.id.toString())"
                    >
                      <mat-icon icon svgIcon="delete"></mat-icon>
                    </mzima-client-button>
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <mat-dialog-actions align="end">
    <mzima-client-button fill="outline" color="secondary" [mat-dialog-close]="false">
      {{ 'app.cancel' | translate }}
    </mzima-client-button>
    <mzima-client-button (buttonClick)="applyChanges()" [disabled]="isButtonDisabled()">
      {{ 'form.save_and_close' | translate }}
    </mzima-client-button>
  </mat-dialog-actions>
</ng-container>

<ng-template #spinner>
  <app-spinner class="spinner"></app-spinner>
</ng-template>
